/**
 * @deprecated This file contains legacy MSAL Azure AD implementation.
 * New SSO implementations should use the SsoService and tenant-based SSO flows.
 * This code is maintained for backward compatibility only.
 *
 * Migration path:
 * - Use SsoService.initiateLogin() instead of MSAL redirect flows
 * - Use tenant-based SSO endpoints: /integrations/saml2/login/
 */

import { MsalBroadcastService, MsalInterceptorConfiguration } from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionStatus,
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';
import { filter } from 'rxjs';

import { environment } from '../../environments/environment';

/**
 * @deprecated Use SsoService instead of MSAL for new implementations
 */
export function msalInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.AZURE_AD_FRONTEND_CLIENT_ID,
      redirectUri: environment.HOST_URL,
      authority: 'https://login.microsoftonline.com/common',
    },
    cache: { cacheLocation: BrowserCacheLocation.LocalStorage },
  });
}

/**
 * @deprecated Token checking will be handled by the new SSO system
 */
function hasMsalToken(): boolean {
  const tokenKey = `msal.token.keys.${environment.AZURE_AD_FRONTEND_CLIENT_ID}`;
  return !!localStorage.getItem(tokenKey);
}

function getMsalScope(): string[] {
  const scope = [`api://${environment.AZURE_AD_BACKEND_CLIENT_ID}/read`];
  return hasMsalToken() ? scope : null;
}

/**
 * @deprecated Use new SSO endpoints instead of MSAL interceptors
 */
export function msalInterceptorConfigFactory(msalBroadcastService: MsalBroadcastService): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[]>();
  protectedResourceMap.set(environment.API_URL, getMsalScope());

  msalBroadcastService.inProgress$
    .pipe(filter((status: InteractionStatus) => status === InteractionStatus.None))
    .subscribe(() => {
      protectedResourceMap.set(environment.API_URL, getMsalScope());
    });

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}
